import * as tslib_1 from "tslib";
import { connect } from 'react-redux';
import { getIsLoggedIn, getWatchCount, getCartCount, getFeedbackCount, getNotesCount, getIsEclipseSwitcherEnabled, getCurrentUserHasWixPortfolio, } from '../publicSession/selectors';
import { siteHeaderSearchButtonClicked, openSubmitMenu, openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, openSearchPopup, closeSearchPopup, } from './redux/actions';
import { switchVersion } from '../publicSession/actions';
import { getSiteHeaderState } from './redux/selectors';
function mapStateToProps(state) {
    return tslib_1.__assign({ isLoggedIn: getIsLoggedIn(state), watchCount: getWatchCount(state), cartCount: getCartCount(state), feedbackCount: getFeedbackCount(state), noteCount: getNotesCount(state), disableVersionSwitcher: !getIsEclipseSwitcherEnabled(state), hasWixPortfolio: !getCurrentUserHasWixPortfolio(state) }, getSiteHeaderState(state));
}
var mapDispatchToProps = {
    onSiteHeaderSearchButtonClicked: siteHeaderSearchButtonClicked,
    switchVersion: switchVersion,
    openSubmitMenu: openSubmitMenu,
    openUserDropdown: openUserDropdown,
    closeUserDropdown: closeUserDropdown,
    openNotificationsDropdown: openNotificationsDropdown,
    closeNotificationsDropdown: closeNotificationsDropdown,
    openSearchPopup: openSearchPopup,
    closeSearchPopup: closeSearchPopup,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeader.container.js.map